const GoogleConfiguration = {
  apiKey: 'AIzaSyB1A5uuq6QNheeZbnqeMdfq3RT_FB4vPGQ',
};

export default GoogleConfiguration;
